import { 
    collection, 
    deleteDoc, 
    doc, 
    getDocs, 
    query, 
    serverTimestamp, 
    setDoc, 
    where 
  } from "firebase/firestore";
  
  export const updateProductAvailableIn = async (
    productRef, 
    userId, 
    action, 
    type, 
    listId = null
  ) => {
    const productId = productRef.id;
    const availableInCollection = collection(productRef, "availableIn");
  
    if (action === 'add') {
   
      const newDocRef = doc(availableInCollection);
      await setDoc(newDocRef, {
        productId,
        userId,
        type,
        ...(listId && { listId }), 
        timestamp: serverTimestamp()
      });
      
    } else if (action === 'remove') {

      const queryConstraints = [
        where("productId", "==", productId),
        where("userId", "==", userId),
        where("type", "==", type)
      ];
      
      if (listId) {
        queryConstraints.push(where("listId", "==", listId));
      }
  
      const q = query(availableInCollection, ...queryConstraints);
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const docToDelete = querySnapshot.docs[0];
        await deleteDoc(docToDelete.ref);
      }
    }
  };